var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.plan.selectFeatures || []).length > 0
    ? _c(
        "div",
        { staticClass: "card-select-feature" },
        [
          _c(
            "a-select",
            {
              model: {
                value: _vm.cloneSelectedFeatureIndex,
                callback: function ($$v) {
                  _vm.cloneSelectedFeatureIndex = $$v
                },
                expression: "cloneSelectedFeatureIndex",
              },
            },
            _vm._l(_vm.plan.selectFeatures, function (selectFeature, index) {
              return _c(
                "a-select-option",
                {
                  key: index,
                  attrs: { value: index, disabled: selectFeature.isDisabled },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getOptionText(selectFeature.count)) +
                      "\n        "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }